import React from 'react';
import PropTypes from 'prop-types';
import { Route, Link } from 'react-router-dom';
import { Menu } from 'antd';

const { SubMenu } = Menu;

const CustomerRoute = (props) => {
  const { customerName, selectedKey, openKey, component: ComponentToRender, componentProps, ...rest } = props;
  const menuProps = {};
  if (openKey) menuProps.openKeys = [openKey];
  return (
    <Route
      {...rest}
      render={(routeProps) => {
        const customerId = routeProps.match.params.id;
        return (
          <div>
            <Menu
              mode="horizontal"
              // theme="dark"
              selectedKeys={[selectedKey]}
            >
              <Menu.Item key="customer-name" disabled>
                {customerName}
              </Menu.Item>
              <Menu.Item key="customer-dashboard">
                <Link to={`/app/customers/${customerId}`}>
                  Dashboard
                </Link>
              </Menu.Item>
              <Menu.Item key="customer-tasks">
                <Link to={`/app/customers/${customerId}/tasks`}>
                  Tasks
                </Link>
              </Menu.Item>
              <SubMenu key="customer-factsheet" title="Factsheet">
                <Menu.Item key="customer-factsheet-dashboard">
                  <Link to={`/app/customers/${customerId}/factsheet`}>
                    Dashboard
                  </Link>
                </Menu.Item>
                <Menu.Item key="customer-factsheet-od">
                  <Link to={`/app/customers/${customerId}/factsheet/od`}>
                    Organizational Details
                  </Link>
                </Menu.Item>
                <Menu.Item key="customer-factsheet-md">
                  <Link to={`/app/customers/${customerId}/factsheet/md`}>
                    Management Details
                  </Link>
                </Menu.Item>
                <Menu.Item key="customer-factsheet-pba">
                  <Link to={`/app/customers/${customerId}/factsheet/pba`}>
                    Present Banking
                  </Link>
                </Menu.Item>
                <Menu.Item key="customer-factsheet-pl">
                  <Link to={`/app/customers/${customerId}/factsheet/pl`}>
                    Proposed Loans
                  </Link>
                </Menu.Item>
                <Menu.Item key="customer-factsheet-securities">
                  <Link to={`/app/customers/${customerId}/factsheet/securities`}>
                    Securities
                  </Link>
                </Menu.Item>
                <Menu.Item key="customer-factsheet-ac">
                  <Link to={`/app/customers/${customerId}/factsheet/ac`}>
                    Associate Concerns
                  </Link>
                </Menu.Item>
                <Menu.Item key="customer-factsheet-add-details">
                  <Link to={`/app/customers/${customerId}/factsheet/addDetails`}>
                    Additional Details
                  </Link>
                </Menu.Item>
              </SubMenu>
              <Menu.Item key="cma">
                <Link to={`/app/customers/${customerId}/cma`}>
                  CMA
                </Link>
              </Menu.Item>
              <Menu.Item key="customer-documents">
                <Link to={`/app/customers/${customerId}/documents`}>
                  All Documents
                </Link>
              </Menu.Item>
            </Menu>
            <ComponentToRender {...routeProps} {...componentProps} />
          </div>
        );
      }}
    />
  );
};

CustomerRoute.propTypes = {
  customerName: PropTypes.string.isRequired,
  component: PropTypes.func.isRequired,
  componentProps: PropTypes.object,
  selectedKey: PropTypes.string.isRequired,
  openKey: PropTypes.string,
};

CustomerRoute.defaultProps = {
  componentProps: {},
  openKey: null,
};

export default CustomerRoute;



// WEBPACK FOOTER //
// ./src/routes/CustomerRoute.jsx